import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AccountSettingComponent } from './account-setting/account-setting.component';
import { AllInvoicesComponent } from './all-invoices/all-invoices.component';
import { AutofillConfigComponent } from './autofill-config/autofill-config.component';
import { BookingConfirmationPreviewComponent } from './booking-confirmation-preview/booking-confirmation-preview.component';
import { BookingDetailComponent } from './booking-detail/booking-detail.component';
import { BookingEmailTemplatesComponent } from './booking-email-templates/booking-email-templates.component';
import { BookingPreConfirmationPreviewComponent } from './booking-pre-confirmation-preview/booking-pre-confirmation-preview.component';
import { BookingPreConfirmationTemplateEditComponent } from './booking-pre-confirmation-template-edit/booking-pre-confirmation-template-edit.component';
import { BookingReportPreviewComponent } from './booking-report-preview/booking-report-preview.component';
import { BookingsBrugesComponent } from './bookings-bruges/bookings-bruges.component';
import { BookingsCurrentComponent } from './bookings-current/bookings-current.component';
import { BookingsDeletedComponent } from './bookings-deleted/bookings-deleted.component';
import { BookingsEtcComponent } from './bookings-etc/bookings-etc.component';
import { BookingsComponent } from './bookings/bookings.component';
import { ConnectedGuardService } from './security/connected-guard.service';
import { ContactRequestEditNavigationComponent } from './contact-request-edit-navigation/contact-request-edit-navigation.component';
import { ContactRequestQuotationPreviewComponent } from './contact-request-quotation-preview/contact-request-quotation-preview.component';
import { CreateBookingEmailTemplateComponent } from './create-booking-email-template/create-booking-email-template.component';
import { CreateBookingComponent } from './create-booking/create-booking.component';
import { CreateBrugesBookingComponent } from './create-bruges-booking/create-bruges-booking.component';
import { CreateBulkInvoicesComponent } from './create-bulk-invoices/create-bulk-invoices.component';
import { CreateContactRequestComponent } from './create-contact-request/create-contact-request.component';
import { CreateEtcBookingComponent } from './create-etc-booking/create-etc-booking.component';
import { CreateLeadEmailTemplateComponent } from './create-lead-email-template/create-lead-email-template.component';
import { CreateQuotationTemplateComponent } from './create-quotation-template/create-quotation-template.component';
import { CreateSalesInvoiceComponent } from './create-sales-invoice/create-sales-invoice.component';
import { CreateSingleBookingComponent } from './create-single-booking/create-single-booking.component';
import { DashboardGeneralClientComponent } from './dashboard-general-client/dashboard-general-client.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { EditBookingBrugesComponent } from './edit-booking-bruges/edit-booking-bruges.component';
import { EditBookingDetailEtcComponent } from './edit-booking-detail-etc/edit-booking-detail-etc.component';
import { EditBookingEmailTemplateComponent } from './edit-booking-email-template/edit-booking-email-template.component';
import { EditBookingComponent } from './edit-booking/edit-booking.component';
import { EditDeletedBookingDetailComponent } from './edit-deleted-booking-detail/edit-deleted-booking-detail.component';
import { EditLeadEmailTemplateComponent } from './edit-lead-email-template/edit-lead-email-template.component';
import { EditPdfTemplateCssComponent } from './edit-pdf-template-css/edit-pdf-template-css.component';
import { EditQuotationTemplateComponent } from './edit-quotation-template/edit-quotation-template.component';
import { EditVademecumComponent } from './edit-vademecum/edit-vademecum.component';
import { EmailTemplateComponent } from './email-template/email-template.component';
import { ErrorApiExceptionComponent } from './error-api-exception/error-api-exception.component';
import { ErrorServerDownComponent } from './error-server-down/error-server-down.component';
import { EtcParentalPermissionComponent } from './etc-parental-permission/etc-parental-permission.component';
import { GlobalBookingFilesComponent } from './global-booking-files/global-booking-files.component';
import { GroupBookingCreateComponent } from './group-booking-create/group-booking-create.component';
import { GroupBookingsComponent } from './group-bookings/group-bookings.component';
import { GuideCreateComponent } from './guide-create/guide-create.component';
import { GuideEditComponent } from './guide-edit/guide-edit.component';
import { GuidesComponent } from './guides/guides.component';
import { LeadEmailTemplatesComponent } from './lead-email-templates/lead-email-templates.component';
import { LeadsComponent } from './leads/leads.component';
import { LinkItemCreateComponent } from './link-item-create/link-item-create.component';
import { LinkItemsManageComponent } from './link-items-manage/link-items-manage.component';
import { LinksComponent } from './links/links.component';
import { LoginComponent } from './login/login.component';
import { LvmsBookingCreateComponent } from './lvms-booking-create/lvms-booking-create.component';
import { MyBookingsComponent } from './my-bookings/my-bookings.component';
import { NotConnectedGuardService } from './security/not-connected-guard.service';
import { NotFoundComponent } from './not-found/not-found.component';
import { Oauth2SuccessComponent } from './oauth2-success/oauth2-success.component';
import { OnlineCourseCreateComponent } from './online-course-create/online-course-create.component';
import { OnlineCoursesComponent } from './online-courses/online-courses.component';
import { PaymentsReceivedComponent } from './payments-received/payments-received.component';
import { PdfTemplateCreateComponent } from './pdf-template-create/pdf-template-create.component';
import { PdfTemplateCssesComponent } from './pdf-template-csses/pdf-template-csses.component';
import { PdfTemplateEditComponent } from './pdf-template-edit/pdf-template-edit.component';
import { PdfTemplateNavigationComponent } from './pdf-template-navigation/pdf-template-navigation.component';
import { ProgrammesComponent } from './programmes/programmes.component';
import { PromotionCreateComponent } from './promotion-create/promotion-create.component';
import { PromotionEditComponent } from './promotion-edit/promotion-edit.component';
import { PromotionsComponent } from './promotions/promotions.component';
import { QuotationTemplatesComponent } from './quotation-templates/quotation-templates.component';
import { RefundRequestCreateComponent } from './refund-request-create/refund-request-create.component';
import { RefundRequestEditComponent } from './refund-request-edit/refund-request-edit.component';
import { RefundRequestsComponent } from './refund-requests/refund-requests.component';
import { SalesInvoiceDetailComponent } from './sales-invoice-detail/sales-invoice-detail.component';
import { SalesInvoicesComponent } from './sales-invoices/sales-invoices.component';
import { SchoolCreateComponent } from './school-create/school-create.component';
import { SchoolDocumentFileEditComponent } from './school-document-file-edit/school-document-file-edit.component';
import { SchoolEditNavigationComponent } from './school-edit-navigation/school-edit-navigation.component';
import { SchoolsComponent } from './schools/schools.component';
import { SiepSalonContactsComponent } from './siep-salon-contacts/siep-salon-contacts.component';
import { SimpleBookingStatsComponent } from './simple-booking-stats/simple-booking-stats.component';
import { SalesReportComponent } from './stats/sales-report/sales-report.component';
import { StripWpTagsComponent } from './strip-wp-tags/strip-wp-tags.component';
import { StudentCreateComponent } from './student-create/student-create.component';
import { StudentEditComponent } from './student-edit/student-edit.component';
import { StudentInformationsComponent } from './student-informations/student-informations.component';
import { StudentsComponent } from './students/students.component';
import { SystemUserCreateComponent } from './system-user-create/system-user-create.component';
import { SystemUserEditComponent } from './system-user-edit/system-user-edit.component';
import { SystemUsersComponent } from './system-users/system-users.component';
import { TestGmailApiComponent } from './test-gmail-api/test-gmail-api.component';
import { TestServerDownComponent } from './test-server-down/test-server-down.component';
import { TestVivawalletComponent } from './test-vivawallet/test-vivawallet.component';
import { TransactionsComponent } from './transactions/transactions.component';
import { TravelCreateComponent } from './travel-create/travel-create.component';
import { TravelEditComponent } from './travel-edit/travel-edit.component';
import { TravelsComponent } from './travels/travels.component';
import { VademecumDetailComponent } from './vademecum-detail/vademecum-detail.component';
import { VivawalletErrorComponent } from './vivawallet-error/vivawallet-error.component';
import { VivawalletSuccessComponent } from './vivawallet-success/vivawallet-success.component';
import { WpBookingRequestEditComponent } from './wp-booking-request-edit/wp-booking-request-edit.component';
import { WpBookingRequestPrintComponent } from './wp-booking-request-print/wp-booking-request-print.component';
import { WpBookingRequestsComponent } from './wp-booking-requests/wp-booking-requests.component';
import { MyInvoicesComponent } from './my-invoices/my-invoices.component';
import { PaymentRemindersComponent } from './payment-reminders/payment-reminders.component';
import { CreateAviInvoiceComponent } from './accounting/create-avi-invoice/create-avi-invoice.component';
import { AviInvoicesComponent } from './accounting/avi-invoices/avi-invoices.component';
import { ConstantContactComponent } from './constant-contact/constant-contact.component';
import { ConstantContactCampaignDetailComponent } from './constant-contact-campaign-detail/constant-contact-campaign-detail.component';
import { AgentCommissionComponent } from './agent-commission/agent-commission.component';
import { SchoolInvoicesToValidateComponent } from './school-invoices-to-validate/school-invoices-to-validate.component';
import { AgentCommissionsUpdateComponent } from './agent-commissions-update/agent-commissions-update.component';
import { AgentCommissionCreatePaymentComponent } from './agent-commission-create-payment/agent-commission-create-payment.component';
import { InvoicesComponent } from "./general-supplier-invoice/invoices/invoices.component";
import { UnpaidInvoicesComponent } from "./general-supplier-invoice/unpaid-invoices/unpaid-invoices.component";
import { CreatePaidInvoiceComponent } from "./general-supplier-invoice/create-paid-invoice/create-paid-invoice.component";
import { CreateUnpaidInvoiceComponent } from "./general-supplier-invoice/create-unpaid-invoice/create-unpaid-invoice.component";
import { RedirectingComponent } from "./redirecting/redirecting.component";
import { EditUnpaidInvoiceComponent } from"./general-supplier-invoice/edit-unpaid-invoice/edit-unpaid-invoice.component";
import { LoginFailComponent } from "./login-fail/login-fail.component";
import { PostLogoutComponent } from "./post-logout/post-logout.component";
import { authGuard } from './security/auth.guard';
import { loginRedirectGuard } from './security/login-redirect-guard';

const routes: Routes = [
  { path: "booking/:uuid", component: BookingDetailComponent},
  { path: "student-informations/:uuid", component: StudentInformationsComponent},
  { path: "etc-parental-permission/:uuid", component: EtcParentalPermissionComponent},
  { path: "dashboard/:uuid", component: DashboardComponent},
  { path: "dashboard-student/:uuid", component: DashboardGeneralClientComponent },
  { path: "vivawallet-success", component: VivawalletSuccessComponent },
  { path: "vivawallet-error", component: VivawalletErrorComponent },
  { path: "login", component: LoginComponent},
  { path: "post-logout", component: PostLogoutComponent },
  { path: "links", component: LinksComponent},
  { path: "redirecting", component: RedirectingComponent },
  { path: "login-fail", component: LoginFailComponent },
  {
    path: "test-bruges-form", component: TestServerDownComponent
  },
  { path: "server-down", component: ErrorServerDownComponent },
  { path: "api-error", component: ErrorApiExceptionComponent },
  {
    path: "management",
    canActivate: [authGuard],
    children: [
      {
        path: "bookings", component: BookingsComponent
      },
      {
        path: "bookings-bruges", component: BookingsBrugesComponent
      },
      {
        path: "bookings-etc", component: BookingsEtcComponent
      },
      {
        path: "create-booking-bruges", component: CreateBrugesBookingComponent
      },
      {
        path: "vademecum/:bookingId", component: VademecumDetailComponent
      },
      { 
        path: "edit-booking/:bookingId", component: EditBookingComponent
      },
      { 
        path: "edit-booking-bruges/:uuid", component: EditBookingBrugesComponent
      },
      {
        path: "edit-booking-etc/:uuid", component: EditBookingDetailEtcComponent
      },
      {
        path: "edit-vademecum/:bookingId", component: EditVademecumComponent
      },
      {
        path: "bookings-deleted", component: BookingsDeletedComponent
      },
      {
        path: "edit-deleted-booking/:uuid", component: EditDeletedBookingDetailComponent
      },
      {
        path: "bookings-current", component: BookingsCurrentComponent
      },
      {
        path: "email-template", component: EmailTemplateComponent
      },
      {
        path: "schools", component: SchoolsComponent
      },
      {
        path: "create-school", component: SchoolCreateComponent
      },
      {
        path: "edit-school/:schoolId", component: SchoolEditNavigationComponent
      },
      {
        path: "autofill", component: AutofillConfigComponent
      },
      {
        path: "guides", component: GuidesComponent
      },
      {
        path: "create-guide", component: GuideCreateComponent
      },
      {
        path: "edit-guide/:guideId", component: GuideEditComponent
      },
      {
        path: "promotions", component: PromotionsComponent
      },
      {
        path: "promotion-create", component: PromotionCreateComponent
      },
      {
        path: "promotion-edit/:promotionId", component: PromotionEditComponent
      },
      {
        path: "create-etc-booking", component: CreateEtcBookingComponent
      },
      {
        path: "create-link", component: LinkItemCreateComponent
      },
      {
        path: "manage-links", component: LinkItemsManageComponent
      },
      {
        path: "online-courses", component: OnlineCoursesComponent
      },
      {
        path: "create-online-course", component: OnlineCourseCreateComponent
      },
      {
        path: "user-config", component: AccountSettingComponent
      },
      {
        path: "strip-wp", component: StripWpTagsComponent
      },
      {
        path: "users", component: SystemUsersComponent
      },
      {
        path: "user-edit/:userId", component: SystemUserEditComponent
      },
      {
        path: "user-create", component: SystemUserCreateComponent
      },
      {
        path: "refund-request-new", component: RefundRequestCreateComponent
      },
      { 
        path: "refund-requests", component: RefundRequestsComponent
      },
      {
        path: "refund-request-edit/:requestId", component: RefundRequestEditComponent
      },
      {
        path: "pdf-template-create", component: PdfTemplateCreateComponent
      },
      { 
        path: "pdf-templates", component: PdfTemplateNavigationComponent
      },
      {
        path: "pdf-template-edit/:templateId", component: PdfTemplateEditComponent
      },
      {
        path: "wp-booking-requests", component: WpBookingRequestsComponent
      },
      {
        path: "wp-booking-request-edit/:requestId", component: WpBookingRequestEditComponent
      },
      {
        path: "wp-booking-request-print/:requestId", component: WpBookingRequestPrintComponent
      },
      {
        path: "lvms-booking-create", component: LvmsBookingCreateComponent
      },
      {
        path: "leads", component: LeadsComponent
      },
      {
        path: "wp-contact-request-edit-navigation/:requestId", component: ContactRequestEditNavigationComponent
      },
      {
        path: "travels", component: TravelsComponent
      },
      {
        path: "travel-create", component: TravelCreateComponent
      },
      {
        path: "travel-edit/:travelId", component: TravelEditComponent
      },
      {
        path: "students", component: StudentsComponent
      },
      {
        path: "student-create", component: StudentCreateComponent
      },
      {
        path: "student-edit/:studentId", component: StudentEditComponent
      },
      {
        path: "booking-report-preview/:reportId", component: BookingReportPreviewComponent
      },
      {
        path: "booking-pre-confirmation-preview/:preconfId", component: BookingPreConfirmationPreviewComponent
      },
      {
        path: "booking-confirmation-preview/:confirmationId", component: BookingConfirmationPreviewComponent
      },
      {
        path: "booking-final-confirmation-preview/:finalConfirmationId", component: BookingConfirmationPreviewComponent
      },
      {
        path: "payments-received", component: PaymentsReceivedComponent
      },
      {
        path: "edit-pdf-css/:cssId", component: EditPdfTemplateCssComponent
      },
      {
        path: "create-contact-request", component: CreateContactRequestComponent
      },
      {
        path: "create-quotation-template", component: CreateQuotationTemplateComponent
      },
      {
        path: "quotation-templates", component: QuotationTemplatesComponent
      },
      {
        path: "edit-quotation-template/:templateId", component: EditQuotationTemplateComponent
      },
      {
        path: "siep-contacts", component: SiepSalonContactsComponent
      },
      {
        path: "create-sales-invoice", component: CreateSalesInvoiceComponent
      },
      {
        path: "sales-invoices", component: SalesInvoicesComponent
      },
      {
        path: "sales-invoice-detail/:invoiceId", component: SalesInvoiceDetailComponent
      },
      {
        path: "pdf-template-csses", component: PdfTemplateCssesComponent
      },
      {
        path: "create-lead-email-template", component: CreateLeadEmailTemplateComponent
      },
      {
        path: "lead-email-templates", component: LeadEmailTemplatesComponent
      },
      {
        path: "edit-lead-email-template/:templateId", component: EditLeadEmailTemplateComponent
      },
      {
        path: "edit-school-document-file/:schoolId", component: SchoolDocumentFileEditComponent
      },
      {
        path: "global-booking-files", component: GlobalBookingFilesComponent
      },
      {
        path: "create-booking-email-template", component: CreateBookingEmailTemplateComponent
      },
      {
        path: "booking-email-templates", component: BookingEmailTemplatesComponent
      },
      {
        path: "edit-booking-email-template/:templateId", component: EditBookingEmailTemplateComponent
      },
      {
        path: "booking-statistiques", component: SimpleBookingStatsComponent
      },
      {
        path: "booking-pre-confirmation-template-edit/:templateId", component: BookingPreConfirmationTemplateEditComponent
      },
      {
        path: "test-gmail-api", component: TestGmailApiComponent
      },
      {
        path: "all-invoices", component: AllInvoicesComponent
      },
      {
        path: "transactions", component: TransactionsComponent
      },
      {
        path: "contact-request-quotation-preview/:quotationId/:language", component: ContactRequestQuotationPreviewComponent
      },
      {
        path: "programmes", component: ProgrammesComponent
      },
      {
        path: "create-invoices", component: CreateBulkInvoicesComponent
      },
      {
        path: "oauth2-success/:message", component: Oauth2SuccessComponent
      },
      {
        path: "create-group-booking", component: GroupBookingCreateComponent
      },
      {
        path: "group-bookings", component: GroupBookingsComponent
      },
      {
        path: "create-booking", component: CreateBookingComponent
      },
      {
        path: "create-single-booking", component: CreateSingleBookingComponent
      },
      {
        path: "test-vivawallet", component: TestVivawalletComponent
      },
      {
        path: "sales-report", component: SalesReportComponent
      },
      {
        path: "my-bookings", component: MyBookingsComponent
      },
      {
        path: "my-invoices", component: MyInvoicesComponent
      },
      {
        path: "payment-reminders", component: PaymentRemindersComponent
      },
      {
        path: "create-avi-invoice", component: CreateAviInvoiceComponent
      },
      {
        path: "avi-invoices", component: AviInvoicesComponent
      },
      {
        path: "constant-contact", component: ConstantContactComponent
      },
      {
        path: "constant-contact-campaign/:campaignId", component: ConstantContactCampaignDetailComponent
      },
      {
        path: "agent-commission", component: AgentCommissionComponent
      },
      {
        path: "agent-commissions-update", component: AgentCommissionsUpdateComponent
      },
      {
        path: "agent-commissions-create-payment", component: AgentCommissionCreatePaymentComponent
      },
      {
        path: "school-invoices-to-validate", component: SchoolInvoicesToValidateComponent
      },
      {
        path: "general-supplier-invoice/invoices", component: InvoicesComponent
      },
      {
        path: "general-supplier-invoice/unpaid-invoices", component: UnpaidInvoicesComponent
      },
      {
        path: "general-supplier-invoice/create-paid-invoice", component: CreatePaidInvoiceComponent
      },
      {
        path: "general-supplier-invoice/create-unpaid-invoice", component: CreateUnpaidInvoiceComponent
      },
      {
        path: "general-supplier-invoice/edit-unpaid-invoice/:invoiceId", component: EditUnpaidInvoiceComponent
      }
    ]
  },
  {
    path: "not-found", component: NotFoundComponent
  },
  {
    path: "**", redirectTo: "not-found"
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {scrollPositionRestoration: 'enabled'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
